var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { nanoid } from "nanoid";
import { logUiLogs } from "../service";
const UUID = nanoid();
export function logDuration({ label, startTime, endTime }) {
    return __awaiter(this, void 0, void 0, function* () {
        const duration = endTime - startTime;
        console.log("Unique ID for logs:", UUID);
        try {
            yield logUiLogs(window === null || window === void 0 ? void 0 : window.uscWidget.config.networkBrand, {
                logMessage: JSON.stringify({
                    label,
                    startTime,
                    endTime,
                    duration,
                    UUID
                }),
                code: label,
                logLevel: "info"
            });
        }
        catch (e) {
            console.error("USC: logDuration error to call logs service failed: ", e.message);
        }
    });
}
